import { render } from "./reservationMain.vue?vue&type=template&id=06281b8b&scoped=true"
import script from "./reservationMain.vue?vue&type=script&lang=js"
export * from "./reservationMain.vue?vue&type=script&lang=js"

import "./reservationMain.vue?vue&type=style&index=0&id=06281b8b&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06281b8b"]])

export default __exports__